import React from 'react';
import { string, shape, bool } from 'prop-types';
import { Button } from '@andes/button';
import { loadable } from 'nordic/lazy';
import RequestModalUnregisteredQuotation from '../../../pages/vip/features/quotations/unregistered-quotation-request-modal';

const Quotation = loadable(() => import('../../../pages/vip/features/quotations/quotation.desktop'));

const namespace = 'ui-pdp-quotation';

const BuildUnregisteredQuotationModal = ({
  itemId,
  type,
  hierarchy,
  label,
  deviceType,
  track,
  disabled,
  recaptchaSiteKey,
}) => (
  <RequestModalUnregisteredQuotation
    contentComponent={<Quotation recaptchaSiteKey={recaptchaSiteKey} />}
    className={`${namespace}__container-request-modal`}
    itemId={itemId}
    deviceType={deviceType}
    modalClassName={`${namespace}__modal`}
    track={track}
    isLoginRequired={false}
    disabled={disabled}
  >
    <Button hierarchy={hierarchy} type={type} disabled={disabled}>
      {label && label.text}
    </Button>
  </RequestModalUnregisteredQuotation>
);

BuildUnregisteredQuotationModal.propTypes = {
  itemId: string.isRequired,
  type: string,
  hierarchy: string,
  label: shape({
    text: string,
  }),
  deviceType: string.isRequired,
  recaptchaSiteKey: string,
  track: shape({}).isRequired,
  disabled: bool,
};

BuildUnregisteredQuotationModal.defaultProps = {
  type: null,
  hierarchy: null,
  label: null,
  recaptchaSiteKey: null,
  disabled: false,
};

export default BuildUnregisteredQuotationModal;
